<script lang="ts">
  // Components
  import { Grid } from '$lib/components/organisms/Layout';

  export let disableLastElementLink = false;
</script>

<div class="breadcrumb-wrapper">
  <Grid noGrid>
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <ol class="breadcrumb-list" class:disable-last={disableLastElementLink}>
        <slot />
      </ol>
    </nav>
  </Grid>
</div>

<style type="text/scss" lang="scss" scoped>
  .breadcrumb-wrapper {
    @apply bg-white;
    @apply hidden md:block;
  }
  .breadcrumb {
    @apply py-2;
    @apply text-sm;
  }

  .breadcrumb-list {
    @apply flex flex-wrap items-center;
  }

  :global(.breadcrumb > .breadcrumb-list.disable-last > *:last-child) {
    @apply pointer-events-none cursor-text;
  }
</style>
